/* OKARI Aging-Odor Quiz Funnel — state machine + results logic */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__oqInit) return;
    root.__oqInit = true;

    var uid     = root.getAttribute('data-uid') || 'oq';
    var SKEY    = 'oq:' + uid;
    var steps   = [].slice.call(root.querySelectorAll('[data-step]'));
    if (!steps.length) return;
    var progFill = root.querySelector('[data-prog]');
    var TOTAL    = parseInt(root.getAttribute('data-total'), 10) || 16;
    var answers  = {};           // qkey -> { tag, label }
    var current  = -1;
    var timers   = [];

    /* ---------- persistence ---------- */
    function save() {
      try {
        sessionStorage.setItem(SKEY, JSON.stringify({ step: current, answers: answers }));
      } catch (e) {}
    }
    function load() {
      try {
        var raw = sessionStorage.getItem(SKEY);
        if (!raw) return null;
        var d = JSON.parse(raw);
        if (d && typeof d.step === 'number') return d;
      } catch (e) {}
      return null;
    }

    /* ---------- analytics ---------- */
    function track(name, detail) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, detail || {}));
      } catch (e) {}
      try {
        root.dispatchEvent(new CustomEvent(name, { detail: detail || {}, bubbles: true }));
      } catch (e) {}
    }

    /* ---------- step machine ---------- */
    function clearTimers() {
      timers.forEach(function (t) { clearTimeout(t); clearInterval(t); });
      timers = [];
    }
    function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }

    function show(i, opts) {
      opts = opts || {};
      if (i < 0 || i >= steps.length) return;
      clearTimers();
      current = i;

      steps.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });

      if (progFill) {
        var pct = Math.min(100, Math.round((i / TOTAL) * 100));
        progFill.style.width = pct + '%';
      }

      if (!opts.silent) {
        try { window.scrollTo(0, 0); } catch (e) {}
      }
      if (!opts.noHistory) {
        try { history.pushState({ oq: uid, step: i }, '', location.pathname + location.search); } catch (e) {}
      }

      save();
      track('quiz_step_view', { step: i + 1, quiz: uid });

      var el = steps[i];
      var auto = el.getAttribute('data-auto');
      if (auto === 'ring')     runRing(el);
      if (auto === 'rows')     runRows(el);
      if (auto === 'redirect') runRedirect(el);
      if (el.hasAttribute('data-results'))    renderResults(el);
      if (el.hasAttribute('data-projection')) runProjection(el);
    }

    function next() { if (current < steps.length - 1) show(current + 1); }

    /* ---------- answers ---------- */
    root.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.oq-opt');
      if (btn && root.contains(btn)) {
        ev.preventDefault();
        var group = btn.closest('[data-step]');
        var qkey  = group ? (group.getAttribute('data-qkey') || 'q' + steps.indexOf(group)) : 'q';
        [].slice.call(group.querySelectorAll('.oq-opt')).forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        answers[qkey] = {
          tag:   (btn.getAttribute('data-tag') || '').trim(),
          label: (btn.getAttribute('data-label') || btn.textContent || '').trim()
        };
        save();
        track('quiz_answer', { step: current + 1, question: qkey, answer: answers[qkey].label, tag: answers[qkey].tag });
        later(next, REDUCED ? 0 : 250);
        return;
      }
      var adv = ev.target.closest('[data-next]');
      if (adv && root.contains(adv)) { ev.preventDefault(); next(); }
    });

    /* ---------- back button ---------- */
    window.addEventListener('popstate', function (e) {
      var s = e.state && e.state.oq === uid ? e.state.step : null;
      if (s === null || s === undefined) { if (current > 0) show(current - 1, { noHistory: true }); }
      else show(s, { noHistory: true });
    });

    /* ---------- step 10: analysing ring ---------- */
    function runRing(el) {
      var bar = el.querySelector('.bar'), num = el.querySelector('[data-ring-num]'), lbl = el.querySelector('[data-ring-lbl]');
      if (!bar) return;
      var C = 2 * Math.PI * 86;
      bar.style.strokeDasharray = C;
      bar.setAttribute('stroke-dasharray', C);
      var doneTxt = el.getAttribute('data-label-done') || 'Complete';
      var busyTxt = el.getAttribute('data-label-busy') || 'Analyzing';
      var DUR = parseInt(el.getAttribute('data-duration'), 10) || 4000;
      var HOLD = parseInt(el.getAttribute('data-hold'), 10) || 1000;

      function paint(p) {
        bar.setAttribute('stroke-dashoffset', C * (1 - p));
        if (num) num.textContent = Math.round(p * 100) + '%';
        if (lbl) lbl.textContent = p >= 1 ? doneTxt : busyTxt;
      }

      if (REDUCED) { paint(1); later(next, HOLD); return; }

      paint(0);
      var t0 = Date.now();
      var iv = setInterval(function () {
        var t = Math.min(1, (Date.now() - t0) / DUR);
        paint(1 - Math.pow(1 - t, 2.2));
        if (t >= 1) { clearInterval(iv); paint(1); later(next, HOLD); }
      }, 40);
      timers.push(iv);
    }

    /* ---------- step 15: building rows ---------- */
    function runRows(el) {
      var rows = [].slice.call(el.querySelectorAll('.oq-row'));
      var foot = el.querySelector('[data-rows-foot]');
      var busy = el.getAttribute('data-foot-busy') || 'Your results are almost ready';
      var done = el.getAttribute('data-foot-done') || 'Your results are ready';
      var GAP  = parseInt(el.getAttribute('data-gap'), 10) || 1100;
      if (!rows.length) { later(next, 600); return; }

      rows.forEach(function (r) { r.setAttribute('data-state', 'pending'); });
      if (foot) foot.textContent = busy;

      if (REDUCED) {
        rows.forEach(function (r) { r.setAttribute('data-state', 'done'); });
        if (foot) foot.textContent = done;
        later(next, 800);
        return;
      }

      var i = 0;
      function step() {
        if (i > 0) rows[i - 1].setAttribute('data-state', 'done');
        if (i < rows.length) {
          rows[i].setAttribute('data-state', 'active');
          i++;
          later(step, GAP);
        } else {
          if (foot) foot.textContent = done;
          later(next, 1000);
        }
      }
      step();
    }

    /* ---------- step 19: applying-discount loader, then redirect ---------- */
    function runRedirect(el) {
      var rows = [].slice.call(el.querySelectorAll('.oq-row'));
      var GAP  = parseInt(el.getAttribute('data-gap'), 10)  || 1100;
      var HOLD = parseInt(el.getAttribute('data-hold'), 10) || 1000;

      function destination() {
        var url  = (el.getAttribute('data-url')  || '/').trim() || '/';
        var code = (el.getAttribute('data-code') || '').trim();
        if (!code) return url;
        // a code turns this into a real Shopify discount link
        try {
          var u = new URL(url, location.href);
          var path = u.pathname + u.search + u.hash;
          return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(path);
        } catch (e) {
          return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(url);
        }
      }

      function go() {
        // never navigate away while the merchant is editing the section
        if (window.Shopify && window.Shopify.designMode) {
          track('quiz_redirect_suppressed', { quiz: uid, to: destination() });
          return;
        }
        track('quiz_redirect', { quiz: uid, to: destination() });
        try { window.location.href = destination(); } catch (e) {}
      }

      if (!rows.length) { later(go, HOLD); return; }
      rows.forEach(function (r) { r.setAttribute('data-state', 'pending'); });

      if (REDUCED) {
        // keep the timing, drop the transitions
        var i0 = 0;
        var tick = function () {
          if (i0 > 0) rows[i0 - 1].setAttribute('data-state', 'done');
          if (i0 < rows.length) { rows[i0].setAttribute('data-state', 'active'); i0++; later(tick, GAP); }
          else later(go, HOLD);
        };
        tick();
        return;
      }

      var i = 0;
      function step() {
        if (i > 0) rows[i - 1].setAttribute('data-state', 'done');
        if (i < rows.length) { rows[i].setAttribute('data-state', 'active'); i++; later(step, GAP); }
        else later(go, HOLD);
      }
      step();
    }

    /* ---------- results logic ---------- */
    function tagSet() {
      var s = {};
      Object.keys(answers).forEach(function (k) { if (answers[k] && answers[k].tag) s[answers[k].tag] = 1; });
      return s;
    }
    function hasPrefix(set, p) {
      return Object.keys(set).some(function (t) { return t.indexOf(p) === 0; });
    }

    function compute(el) {
      var T = tagSet();
      var has = function (t) { return !!T[t]; };
      var g = function (n, d) { var v = el.getAttribute(n); return (v === null || v === '') ? d : v; };

      var causes = [];
      if (has('meno_yes') || has('meno_now'))                  causes.push(g('data-cause-meno', 'Menopause'));
      if (hasPrefix(T, 'age_') && !has('age_under40'))         causes.push(g('data-cause-age', 'Age'));
      if (has('alc_mid') || has('alc_high'))                   causes.push(g('data-cause-alcohol', 'Regular alcohol'));
      if (has('med_yes'))                                      causes.push(g('data-cause-med', 'Medication changes'));
      if (has('night_most') || has('night_some'))              causes.push(g('data-cause-night', 'Night sweats'));

      var signChecks = [
        has('frag_more') || has('frag_bit'),
        has('ears_often') || has('ears_occ'),
        has('marks_pillow') || has('marks_yellow') || has('marks_collar'),
        hasPrefix(T, 'home_') && !has('home_yes'),
        has('comp_years') || has('comp_never'),
        has('wash_bar') || has('wash_gel') || has('wash_anti')
      ];
      var signs = signChecks.filter(Boolean).length;

      var score = causes.length * 2 + signs;
      var pos   = Math.round(Math.min(78, 56 + score * 1.4));
      var low   = pos < 62;

      var n = causes.length;
      var primary   = causes[0] || g('data-fallback-primary', 'Changes in skin oil');
      var secondary = causes[1] || (signs ? g('data-fallback-secondary', 'Daily habits') : g('data-cause-age', 'Age'));

      var summary;
      if (n) {
        summary = g('data-summary', 'Your answers match {n} common cause{s} of age-related odor, led by {primary}.')
          .replace('{n}', n).replace('{s}', n > 1 ? 's' : '').replace('{primary}', primary.toLowerCase());
      } else {
        summary = g('data-summary-none', 'Your answers show signs linked to changes in skin oil, a common cause of age-related odor.');
      }

      var keySign;
      if      (has('marks_pillow')) keySign = g('data-sign-pillow', 'Pillowcase marks');
      else if (has('marks_yellow')) keySign = g('data-sign-yellow', 'Yellowish patches');
      else if (has('marks_collar')) keySign = g('data-sign-collar', 'Collar stains');
      else if (has('ears_often') || has('ears_occ'))      keySign = g('data-sign-ears', 'Itchy ears');
      else if (has('frag_more')  || has('frag_bit'))      keySign = g('data-sign-frag', 'More fragrance');
      else if (hasPrefix(T, 'home_') && !has('home_yes')) keySign = g('data-sign-nose', 'Nose blindness');
      else if (has('comp_years') || has('comp_never'))    keySign = g('data-sign-comp', 'Fewer compliments');
      else keySign = g('data-sign-default', 'Skin oil changes');

      return {
        pos: pos,
        level:      low ? g('data-level-low', 'Moderate')  : g('data-level-high', 'Moderate to high'),
        likelihood: low ? g('data-lk-low', 'Likely')       : g('data-lk-high', 'Highly likely'),
        primary: primary, secondary: secondary, summary: summary, keySign: keySign,
        routine: has('wash_deo') ? g('data-routine-partly', 'Partly targeting it') : g('data-routine-not', 'Not targeting odor'),
        causes: causes.length, signs: signs, score: score
      };
    }

    function renderResults(el) {
      var r = compute(el);
      var put = function (sel, v) { var n = el.querySelector(sel); if (n) n.textContent = v; };
      put('[data-r-level]',      r.level);
      put('[data-r-summary]',    r.summary);
      put('[data-r-likelihood]', r.likelihood);
      put('[data-r-primary]',    r.primary);
      put('[data-r-secondary]',  r.secondary);
      put('[data-r-sign]',       r.keySign);
      put('[data-r-routine]',    r.routine);
      var mk = el.querySelector('[data-r-marker]');
      if (mk) {
        mk.style.left = '56%';
        (REDUCED ? function (f) { f(); } : function (f) { later(f, 60); })(function () { mk.style.left = r.pos + '%'; });
      }
      try {
        root.__oqResult = r;
        sessionStorage.setItem(SKEY + ':result', JSON.stringify(r));
      } catch (e) {}
      track('quiz_result', { quiz: uid, level: r.level, likelihood: r.likelihood, primary: r.primary, score: r.score });
    }

    /* ---------- step 17: projection ---------- */
    function runProjection(el) {
      var days = parseInt(el.getAttribute('data-days'), 10);
      if (isNaN(days)) days = 6;
      var d = new Date(); d.setDate(d.getDate() + days);
      var txt;
      try { txt = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
      catch (e) { txt = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()] + ' ' + d.getDate(); }
      [].slice.call(el.querySelectorAll('[data-proj-date]')).forEach(function (n) { n.textContent = txt; });
      var card = el.querySelector('.oq-proj');
      if (card) { card.classList.remove('is-on'); later(function () { card.classList.add('is-on'); }, 80); }
    }

    /* ---------- boot ---------- */
    var saved = load();
    if (saved && saved.answers) {
      answers = saved.answers;
      // restore the selected pill on each answered question
      steps.forEach(function (s) {
        var k = s.getAttribute('data-qkey');
        if (!k || !answers[k]) return;
        [].slice.call(s.querySelectorAll('.oq-opt')).forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-tag') === answers[k].tag ? 'true' : 'false');
        });
      });
    }
    var start = saved && saved.step >= 0 && saved.step < steps.length ? saved.step : 0;
    // never resume ON an auto-advancing interstitial — step back to the question before it
    while (start > 0 && steps[start].getAttribute('data-auto')) start--;
    show(start, { silent: true, noHistory: true });
    try { history.replaceState({ oq: uid, step: start }, '', location.pathname + location.search); } catch (e) {}

    // restart control
    var reset = root.querySelector('[data-oq-restart]');
    if (reset) reset.addEventListener('click', function (e) {
      e.preventDefault();
      answers = {};
      try { sessionStorage.removeItem(SKEY); sessionStorage.removeItem(SKEY + ':result'); } catch (er) {}
      [].slice.call(root.querySelectorAll('.oq-opt')).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      show(0);
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-oq]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // theme editor re-renders the section without re-running this file
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-oq]');
    if (r) { r.__oqInit = false; init(r); }
  });
})();
